import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { EmailAuditRow } from '../../schemas/EmailAudit.schema';
import { fetchRequestEmailAudits } from '../queries/KpiCollectionQueries';

export const requestEmailAuditKeys = {
  detail: (requestId: string) => ['request-email-audits', requestId] as const,
};

// Lazy: only fires when `enabled` (the modal is open) and both ids are known.
// Keyed per request so re-opening a previously-viewed request serves from cache.
export function useRequestEmailAudits(
  requestId: string | undefined,
  requestSource: 'firm' | 'universal' | undefined,
  enabled: boolean
): UseQueryResult<EmailAuditRow[], Error> {
  return useQuery({
    queryKey: requestEmailAuditKeys.detail(requestId ?? ''),
    queryFn: () =>
      fetchRequestEmailAudits({
        requestId: requestId as string,
        requestSource: requestSource as 'firm' | 'universal',
      }),
    enabled: enabled && !!requestId && !!requestSource,
    staleTime: 60_000,
  });
}
